import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import LayoutListDemo from './LayoutListDemo'
import LayoutListElement from './LayoutListElement'
import LayoutListFormBrand from './LayoutListFormBrand'
import { STYLE_FORM_SCHEMA } from './LayoutListFormStyle'
import LayoutListFormValue from './LayoutListFormValue'
import icon from './assets/list.svg'

export default genElementConfig(CONFIG_ELEMENTS.layoutList, {
  icon,
  group: ElementGroup.view,
  label: t('elements.layoutList.label'),
  styleFields: STYLE_FORM_SCHEMA,
  Element: LayoutListElement,
  Demo: [LayoutListDemo],
  FormValue: LayoutListFormValue,
  FormBrand: LayoutListFormBrand,
  EditorActions: null,
})
